/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/tracey/"

const TRACEY: CommunityData = {
  code: "tracey",
  inviteCode: "tracey",
  name: "tracey",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/tra-030`,
  waitlist: false,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop: `${S3_PREFIX}web-background.mp4?type=video`,
        mobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
        style: "bg-[#222222]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[120px] h-[30px] sm:w-[166px] sm:h-[42px]",
      },
      werzLogoColor: "#FFFFFF",
      title:
        "font-['HelveticaNeueLTPro83HeavyExtended'] text-[28px] leading-[120%] text-[#ffffff] lowercase",
      text: "font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-[#ffffff]",
      button:
        "font-['HelveticaNeueLTPro83HeavyExtended'] text-[14px] leading-[120%] lowercase p-4 bg-[#fda7f3] text-[#000000] cursor-pointer w-fit",
      input: {
        base: "font-['HelveticaNeueRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#222222] text-[#ffffff]",
        border: "#444444",
        borderFocus: "#6d6d6d",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['HelveticaNeueRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['HelveticaNeueRegular'] text-[14px] leading-[120%] text-[#8d8d8d]",
      skipButton:
        "font-['HelveticaNeueRegular'] text-[14px] leading-[120%] text-[#8d8d8d] cursor-pointer",
      modal: {
        container: "bg-[#222222] px-[40px] py-[48px]",
        title:
          "font-['HelveticaNeueLTPro83HeavyExtended'] text-[24px] leading-[120%] text-[#ffffff] text-center lowercase",
        text: "font-['HelveticaNeueRegular'] text-[14px] leading-[120%] text-[#8d8d8d] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#ffffff] bg-[#000000] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#444444",
        otpBorderFocus: "#6d6d6d",
      },
    },
    global: {
      counterColor: "#ffffff",
      logo: {
        src: "https://media.werz.at/community/icon/cmo8ppmm500009k0g7e7qz5pt.jpg?uploadTime=1776794415268&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[166px] h-[42px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "border-r border-dashed border-[#8d8d8d]",
      contentBg: "#000000",
      contentBoxShadow: "!rounded-2xl",
      bgDesktop: `${S3_PREFIX}web-background.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      mainFont: "font-['HelveticaNeueRegular']",
      primaryButton:
        "bg-[#fda7f3] border border-[#fda7f3] rounded-lg px-[18px] py-[18px] !text-[#000000] font-['HelveticaNeueLTPro83HeavyExtended'] !text-[14px] text-left leading-[100%] lowercase",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-dashed border-[#8d8d8d]",
      separator: "border-dashed border-[#8d8d8d]",
      item: "font-['HelveticaNeueLTPro83HeavyExtended'] text-[14px] text-[#ffffff] text-left leading-[100%] gap-x-[10px] lowercase text-opacity-50 text-center border-b border-dashed border-[#8d8d8d] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] rounded-2xl !pb-8",
      titles:
        "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[24px] text-left leading-[100%] lowercase",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer:
          "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b !border-dashed border-[#8d8d8d]",
        sectionTitle:
          "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[24px] text-left leading-[100%] lowercase pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#dddfde00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[14px] text-left leading-[100%] lowercase",
          subtitle:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[13px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer:
          "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b !border-dashed border-[#8d8d8d]",
        sectionTitle:
          "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[24px] text-left leading-[100%] lowercase pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#dddfde00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[14px] text-left leading-[100%] lowercase",
          subtitle:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[13px] text-left leading-[120%] mt-2",
          location:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[13px] text-left leading-[120%] mt-1",
          date: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[13px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[22px] text-left leading-[100%] lowercase",
        text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[24px] text-left leading-[100%] lowercase !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop:
        "https://media.werz.at/community-assets/tracey/web-background-non-member.mp4?type=video",
      bgMobile:
        "https://media.werz.at/community-assets/tracey/web-background-non-member.mp4?type=video",
      bgColor: "#000000",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#000000]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#ffffff]",
        name: "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[24px] leading-[24px] text-center text-center mt-4 mb-1",
        location:
          "font-['HelveticaNeueLTPro83HeavyExtended'] leading-[16px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#ffffff",
        button:
          "bg-[#dddfde00] border border-[#fda7f3] rounded-lg px-[16px] py-[16px] text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[12px] text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#ffffff] rounded-2xl text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#000000] border border-[#ffffff] rounded-2xl",
          title:
            "font-['HelveticaNeueLTPro83HeavyExtended'] leading-[16px] text-[16px] text-left text-center mb-1",
          text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center text-center",
          button:
            "bg-[#dddfde00] border border-[#fda7f3] rounded-lg px-[16px] py-[16px] text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[12px] text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] leading-[16px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#ffffff] rounded-2xl",
          duration:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[13px] leading-[15.6px] text-left",
          name: "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] leading-[16px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#ffffff",
          media: "overflow-hidden m-2 border border-[#ffffff] rounded-[8px]",
        },
        event: {
          container:
            "overflow-hidden sm:w-[500px] w-[95vw] bg-[#000000] border border-[#ffffff] rounded-2xl",
          name: "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] leading-[16px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#000000] border border-[#fda7f3] rounded-[8px] text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[14px] leading-[14px] text-center",
          duration:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[13px] leading-[15.6px] text-left",
          location:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[13px] leading-[15.6px] text-left",
          button:
            "bg-[#dddfde00] border border-[#fda7f3] rounded-lg px-[16px] py-[16px] text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[12px] text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#ffffff]",
            name: "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] leading-[14px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] leading-[14px] text-[14px] text-left",
            link: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] leading-[16.8px] text-left",
            status:
              "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] leading-[100%] lowercase text-[14px] text-left",
            button:
              "bg-[#dddfde00] border border-[#fda7f3] rounded-lg px-[16px] py-[16px] text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[12px] text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#ffffff] rounded-2xl text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] leading-[16px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#ffffff] rounded-2xl",
          name: "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] leading-[16px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#ffffff",
          created:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[13px] leading-[15.6px] text-left",
          media: "overflow-hidden m-2 border border-[#ffffff] rounded-[8px]",
        },
        seeAllNews:
          "text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#ffffff] rounded-2xl text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] leading-[16px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#ffffff] rounded-2xl",
          coverUrl: "overflow-hidden m-2 border border-[#ffffff] rounded-[8px]",
          duration:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[13px] leading-[15.6px] text-left",
          liveType:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[13px] leading-[15.6px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#fda7f3] rounded-full",
          playIconColor: "#000000",
          playIconBackgroundColor: "#fda7f3",
          playIconBorderColor: "#000000",
          start:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[13px] leading-[15.6px] text-left",
          title:
            "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] leading-[16px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#ffffff] rounded-2xl text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] leading-[16px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#ffffff] rounded-2xl",
          name: "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] leading-[16px] text-[16px] text-left",
          triangleIconColor: "#ffffff",
          circleIcon:
            "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#ffffff] rounded-[8px]",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[13px] leading-[15.6px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] rounded-2xl !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-dashed border-[#8d8d8d]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 rounded-lg !border-0",
        title:
          "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[24px] text-left leading-[100%] lowercase",
        subtitle:
          "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#fda7f3] border border-[#fda7f3] rounded-lg px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['HelveticaNeueLTPro83HeavyExtended'] !text-[14px] text-left leading-[100%] lowercase",
        questions: "text-[14px] text-left leading-[120%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-dashed border-[#8d8d8d]",
        header:
          "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[22px] text-left leading-[100%] lowercase",
        text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-dashed border-[#8d8d8d]",
        header:
          "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[22px] text-left leading-[100%] lowercase",
        text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#fda7f3",
        mapStrokeColor: "#fda7f300",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[22px] text-left leading-[100%] lowercase",
        text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[22px] text-left leading-[100%] lowercase px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] rounded-2xl !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#dddfde00] border border-[#fda7f3] rounded-lg px-[16px] py-[16px] text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[12px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#dddfde00] border-b border-dashed border-[#8d8d8d] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[14px] text-left leading-[100%] lowercase mb-1",
          description:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[14px] text-left leading-[100%] lowercase",
          quantity:
            "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[12px] text-left leading-[100%]",
          status:
            "text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[14px] text-left leading-[100%] lowercase",
          counterContainer:
            "bg-[#dddfde00] border border-[#fda7f3] rounded-lg px-[16px] py-[16px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#dddfde00] border border-[#fda7f3] rounded-lg px-[16px] py-[16px] text-[#ffffff] font-['HelveticaNeueLTPro83HeavyExtended'] text-[12px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#fda7f3",
        },
      },
    },
  },
}

export default TRACEY
